import axios from "../axios";

const searchPartner = async function (accessToken,q = {}) {
    try {
        const response = await axios.get('partner/searchPartner' ,{
            params: {
                q
            },
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default searchPartner;
